import CircularProgress from '@mui/material/CircularProgress';

export default function SessionStatus() {
  return (
    <div style={{ padding: 32, textAlign: 'center' }}>
      <CircularProgress aria-label='Checking sign-in' />
    </div>
  );
}
